import { all, fork } from 'redux-saga/effects'

import { watchHandleLogout } from './auth'
import {
  watchFetchClassEntity,
  watchUpdateClassEntity,
  watchCreateDemoClassBooking,
  watchCreateClassBooking,
  watchCreateExcelBooking
} from './classEntity'
import { watchFetchGeographicalEntities } from './common'
import {
  watchFetchCommunicationEntity,
  watchHandleBulkMessagingEvents,
  watchHandleBulkMessagingFetchEvents,
  watchUpdateCommunicationEntity,
  watchHandleCreateAnnouncement,
  watchHandleCreateAnnouncementSuccess,
  watchHandleUpdateAnnouncementStatus,
  watchHandleFetchAnnouncementsForReorder,
  watchHandleSaveAnnouncementOrder
} from './communicationEntity'
import {
  watchFetchCommunityEntity,
  watchUpdateCommunityEntity
} from './communityEntity'
import { watchFetchEventEntity, watchUpdateEventEntity } from './eventEntity'
import { watchFetchOrdersEntity } from './ordersEntity'
import {
  watchFetchPaymentEntity,
  watchUpdatePaymentEntity
} from './paymentEntity'
import {
  watchFetchLessonPlannerEntity,
  watchUpdateLessonPlannerEntity
} from './lessonPlannerEntity'
import {
  watchFetchPreschoolEntity,
  watchUpdatePreschoolEntity
} from './preschoolEntity'
import { watchFetchSpaceEntity, watchUpdateSpaceEntity } from './spaceEntity'
import { watchFetchUserEntity, watchUpdateUserEntity } from './userEntity'

const sagas = [
  fork(watchHandleLogout),
  fork(watchFetchUserEntity),
  fork(watchUpdateUserEntity),
  fork(watchFetchClassEntity),
  fork(watchUpdateClassEntity),
  fork(watchCreateDemoClassBooking),
  fork(watchCreateClassBooking),
  fork(watchCreateExcelBooking),
  fork(watchFetchSpaceEntity),
  fork(watchUpdateSpaceEntity),
  fork(watchFetchCommunicationEntity),
  fork(watchUpdateCommunicationEntity),
  fork(watchHandleBulkMessagingEvents),
  fork(watchHandleBulkMessagingFetchEvents),
  fork(watchHandleCreateAnnouncement),
  fork(watchHandleCreateAnnouncementSuccess),
  fork(watchHandleUpdateAnnouncementStatus),
  fork(watchHandleFetchAnnouncementsForReorder),
  fork(watchHandleSaveAnnouncementOrder),
  fork(watchFetchCommunityEntity),
  fork(watchUpdateCommunityEntity),
  fork(watchFetchEventEntity),
  fork(watchUpdateEventEntity),
  fork(watchFetchGeographicalEntities),
  fork(watchFetchOrdersEntity),
  fork(watchFetchPaymentEntity),
  fork(watchUpdatePaymentEntity),
  fork(watchFetchPreschoolEntity),
  fork(watchUpdatePreschoolEntity),
  fork(watchFetchLessonPlannerEntity),
  fork(watchUpdateLessonPlannerEntity)
]

export default function* rootSaga() {
  yield all(sagas)
}
